import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import initialState from '../store';
import { isEmpty } from 'lodash';
import { planningGetParamsRoutine } from '@modules/planning/actions';
import { PlannerParamsResponse } from '@modules/planning/types/params';
import { defaultPlannerParams } from '@modules/planning/constants/planner';

export const getPlanningParamsReducer = createReducer(initialState, {
  [planningGetParamsRoutine.REQUEST]: (state) => {
    return state;
  },
  [planningGetParamsRoutine.SUCCESS]: (state, action: PayloadAction<PlannerParamsResponse>) => {
    const { value } = action.payload;
    if (value) {
      const currentValue = Object.keys(value).reduce(
        (acc, key) => {
          if (isEmpty(value[key])) {
            acc[key] = {};
          } else {
            acc[key] = value[key];
          }
          return acc;
        },
        { ...defaultPlannerParams }
      );
      state.localConf = currentValue;
    } else {
      state.localConf = { ...defaultPlannerParams };
    }
    return state;
  },
  [planningGetParamsRoutine.FAILURE]: (state) => {
    return state;
  },
  [planningGetParamsRoutine.FULFILL]: (state) => {
    return state;
  }
});

